<template lang="pug" src="./suspendedMenu.pug"></template>

<script>
import { trackAnalyticsEvent } from '../../../utils/analytics.js'
import PATHS from '../../../router/routesMap.js'

export default {
  name: 'SuspendedMenu',

  data () {
    return {
      blockClientSelectButton: false
    }
  },

  computed: {
    applicationList () {
      return this.$store.getters.clientApps
    },
    singleClient () {
      return this.$store.getters.singleClient
    }
  },

  watch: {
    singleClient () {
      this.blockClientSelectButton = this.singleClient
    }
  },

  methods: {
    logout () {
      this.$store.dispatch('logout')
        .then(this.$router.push(PATHS.LOGIN))
    },

    openClientModal () {
      this.$store.dispatch('openClientModal')
    },

    openMyAccountModal () {
      trackAnalyticsEvent(this, 'menu-minha-conta', 'menu-minha-conta-click', 'abrir-modal-minha-conta')
      this.$store.dispatch('openMyAccountModal')
    },

    openAppChangeModal () {
      trackAnalyticsEvent(this, 'menu-troca-app', 'menu-troca-app-click', 'abrir-modal-troca-app')
      this.$store.dispatch('openAppChangeModal')
    }
  },

  mounted () {
    this.blockClientSelectButton = this.singleClient
  }
}
</script>

<style scoped>
/* Menu suspenso */
div[data-popover="suspended-menu"] {
  background: #143965;
  color: #86a0ac;
  font-family: 'Inter', sans-serif;
font-weight: 700;
  font-size: 16px;
  padding: 0;
  border-radius: 5px;
  box-shadow: 0px 15px 25px 0 rgba(52,73,94,.4);
  left: 0 !important;
  top: 0 !important;
  margin-top: 130% !important;
  margin-left: -325.5% !important;
  position: absolute !important;
}

/* Setinha do topo do menu */
div[data-popover="suspended-menu"].dropdown-position-bottom:before {
  border-bottom: 6px solid #143965;
  left: calc(50% - -48px);
}

/* Conjunto de itens do menu */
div[data-popover="suspended-menu"] > ul {
  margin: 0;
  text-align: left;
}

/* Cada item do menu */
div[data-popover="suspended-menu"] li {
  display: inline-block;
  width: 100%;
  padding: 20px;
  cursor: pointer;
  border-radius: 5px;
}

/* Hover de cada item do menu */
div[data-popover="suspended-menu"] li:hover {
  transition: color 0.5s ease;
  color: #fff;
}

/* Ícone de cada item do menu */
div[data-popover="suspended-menu"] li i {
  padding-right: 14px;
  padding-top: 0;
}

/* Wrapper de ícone + span de cada item do menu */
div[data-popover="suspended-menu"] .clickable-item {
  height: 100%;
  cursor: pointer;
}

/* Modificador do item Logout */
div[data-popover="suspended-menu"] li.logout {
  line-height: 14px;
  background-color: #0B2848;
}

/* Modificador do item Logout */
div[data-popover="suspended-menu"] li.logout i {
  padding: 0;
  float: right;
}
</style>



// WEBPACK FOOTER //
// SuspendedMenu.vue?7f80bc2a